import { render, staticRenderFns } from "./ChatFixEdit.vue?vue&type=template&id=5e88ef09"
import script from "./ChatFixEdit.vue?vue&type=script&lang=js"
export * from "./ChatFixEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports